import { render, staticRenderFns } from "./DeleteRunnitBoardDialog.vue?vue&type=template&id=e69b48fa"
import script from "./DeleteRunnitBoardDialog.vue?vue&type=script&lang=ts"
export * from "./DeleteRunnitBoardDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports